module.exports = __webpack_public_path__ + "img/water-flash.776e6f85.svg";